export const SEARCH = Symbol('SEARCH');
/**
 * @param {boolean} searchedByForm
 * @return {{type: symbol, payload: {searchedByForm}}}
 */
export const searchAction = (searchedByForm) => ({
  type: SEARCH,
  payload: { searchedByForm },
});
